import React, { useState } from 'react';
import GroupOptionsConfig from 'shared/components/GroupOptionsConfig';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Button } from 'shared/components/Buttons';
import { SelectClientWrapper } from '../styles';

const SelectClient = ({ loginData, doLogin }) => {
  const { t } = useTranslation();
  const [selectedConfigOption, setSelectedConfigOption] = useState(0);

  const clientOptions = loginData.clients.map((client) => ({
    name: client.clientName,
    value: client.clientId,
  }));

  const onClickConfigOption = (value) => setSelectedConfigOption(value);

  const handleSelectClient = () => {
    doLogin({
      ...loginData,
      clientId: selectedConfigOption,
    });
  };

  return (
    <SelectClientWrapper>
      <div className="my-4 w-100">
        <span className="select-client__title">{t('login_select_client_label')}</span>
      </div>
      <div className="mb-5 w-100">
        <GroupOptionsConfig
          options={clientOptions}
          onClick={onClickConfigOption}
          selectedOption={selectedConfigOption}
        />
      </div>
      <Button
        type="submit"
        color="primary"
        label={t('login_select_client_label_button')}
        onClick={handleSelectClient}
        className="text-uppercase"
        disabled={selectedConfigOption === 0}
      />
    </SelectClientWrapper>
  );
};

SelectClient.propTypes = {
  loginData: PropTypes.objectOf(PropTypes.shape()).isRequired,
  doLogin: PropTypes.func.isRequired,
};

export default SelectClient;
